import React, { useMemo } from 'react';
import { Spinner } from 'reactstrap';
import { cn } from 'helpers/css';
import './loading.css';

const AntdLoading = React.memo(({ size, className }) => {
  const mappingSize = () => {
    const mapping = {
      sm: 16,
      md: 24,
    };

    return mapping[size] || 24;
  };

  return (
    <div className='ant-spin ant-spin-spinning css-var-r1i5' aria-live='polite' aria-busy='true'>
      <span
        role='img'
        aria-label='loading'
        className={cn('anticon anticon-loading anticon-spin ant-spin-dot', className)}
        style={{ fontSize: mappingSize() }}
      >
        <svg
          viewBox='0 0 1024 1024'
          focusable='false'
          data-icon='loading'
          width='1em'
          height='1em'
          fill='currentColor'
          aria-hidden='true'
        >
          <path d='M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z'></path>
        </svg>
      </span>
    </div>
  );
});

/**
 *
 * @param {Object} props
 * @param {'fullScreen' | 'wave' | undefined} props.type
 * @param {'md' | 'sm' | 'lg'} props.size
 * @param {'success' | 'primary' | 'danger' | 'warning'} props.color
 * @param {boolean} props.showLoading
 * @param {string} props.className
 * @param {string} props.classNameSpinner
 * @param {Object} props.style
 * @returns
 */
const Loading = ({
  size = 'md',
  color,
  type,
  showLoading,
  className,
  classNameSpinner,
  style,
  ...props
}) => {
  if (type === 'wave') {
    return (
      <div className='loading-wave'>
        <div className='loading-bar'></div>
        <div className='loading-bar'></div>
        <div className='loading-bar'></div>
        <div className='loading-bar'></div>
      </div>
    );
  }

  if (type === 'fullScreen') {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          backgroundColor: 'rgba(0, 0, 0, 0.2)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: showLoading ? 9999 : -1,
          borderRadius: '0.25rem',
          transition: 'all .5s',
          opacity: showLoading ? 1 : 0,
          top: 0,
          left: 0,
        }}
      >
        <Spinner size={size} color={color} />
      </div>
    );
  }

  const mappingSize = useMemo(
    () => ({
      sm: 16,
      md: 24,
    }),
    [],
  );

  return (
    <div
      className={`${className || ''} loading-icon`}
      style={{ minHeight: 'max-content', ...style }}
    >
      {props.children}
      {/* <Loader2Icon
        className={cn(classNameSpinner, 'tw-animate-spin tw-text-primary')}
        style={{
          fontSize: mappingSize?.[size] || undefined,
        }}
      /> */}
      <AntdLoading className={classNameSpinner} size={size} />
      {/* <Spinner className='border-width-1' size={size} color={color} /> */}
    </div>
  );
};

Loading.defaultProps = {
  color: 'primary',
  showLoading: true,
};

export default Loading;
